import React, { createContext, useReducer } from "react";

export const LettersContext = createContext();
export const LettersDispatch = createContext();

const initialState = {};

function lettersReducer(state, action) {
    switch (action.type) {
        case "setSectionLetters": {
            const { sectionIndex, letters } = action.payload;
            return { ...state, [sectionIndex]: letters };
        }
        case "updateLetterMargin": {
            const { sectionIndex, letterIndex, margin, html } = action.payload;
            const current = state[sectionIndex];
            if (!current || !current[letterIndex]) return state;
            const nextSlice = [...current];
            nextSlice[letterIndex] = {
                ...nextSlice[letterIndex],
                margin,
                html,
            };
            return { ...state, [sectionIndex]: nextSlice };
        }
        case "removeSection": {
            const { sectionIndex } = action.payload;
            const next = {};
            Object.keys(state)
                .map((k) => Number(k))
                .sort((a, b) => a - b)
                .forEach((k) => {
                    if (k < sectionIndex) next[k] = state[k];
                    else if (k > sectionIndex) next[k - 1] = state[k];
                });
            return next;
        }
        case "reset":
            return {};
        default:
            throw new Error("Unknown LettersContext action: " + action.type);
    }
}

export const LettersProvider = ({ children }) => {
    const [lettersMap, dispatch] = useReducer(lettersReducer, initialState);

    return (
        <LettersContext.Provider value={lettersMap}>
            <LettersDispatch.Provider value={dispatch}>
                {children}
            </LettersDispatch.Provider>
        </LettersContext.Provider>
    );
};
